<template>
  <div class="page-container">
    <div class="page-title">{{ $t('menu.franchisee_manage') }}</div>
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i class="el-icon-arrow-down filter-fixed-arrow" :class="{ 'fiter-icon-arrow-route': !showFilterContent }" @click="showFilterContent = !showFilterContent" />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('operation.franchisee_name') }}</div>
              <ScopeSelect
                :value="search.franchisee_id"
                class="filter-item-value"
                :is-remote="true"
                :http-request-method="searchFranchiseeNameOptions"
                :remote-params="getFranchiseeSearchParams"
                :option-label="formatFranchisee"
                :select-placeholder="$t('operation.select_franchisee')"
                @updateValue="search.franchisee_id = $event"
              />
            </div>
            <div class="filter-item" />
            <div class="filter-item" />
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreatePage">{{ $t('operation.create_franchisee') }}</el-button>
            </div>
            <div class="filter-operate-right">
              <el-button size="small" @click="resetSearch">{{ $t('components.clear') }}</el-button>
              <el-button type="primary" size="small" icon="el-icon-search" @click="searchFranchisees">{{ $t('components.search') }}</el-button>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="tableContainer">
      <el-table v-loading="listLoading" :data="tableData" stripe fit highlight-current-row style="width: 100%">
        <el-table-column prop="franchisee_no" :label="$t('operation.franchisee_no')" min-width="150" align="center" />
        <el-table-column prop="franchisee_name" :label="$t('operation.franchisee_name')" min-width="180" align="center" />
        <el-table-column prop="country_code" :label="$t('operation.region')" min-width="140" align="center" />
        <el-table-column prop="currency" :label="$t('operation.currency')" min-width="130" align="center" />
        <el-table-column prop="remark" :label="$t('operation.remark')" min-width="220" align="center" show-overflow-tooltip />
        <el-table-column prop="create_time" :label="$t('operation.create_time')" min-width="170" align="center" />
        <el-table-column :label="$t('components.operation')" min-width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetailPage(scope.row)">{{ $t('components.detail') }}</el-button>
            <el-button type="text" size="small" @click="openEditPage(scope.row)">{{ $t('components.edit') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { fetchFranchiseeList, searchFranchisees } from '@/api/operation-manage/franchisee'
import { filterEmptyAttr } from '@/utils/common'

export default {
  name: 'FranchiseeManageList',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      showFilterContent: true,
      listLoading: false,
      search: {
        franchisee_name: ''
      },
      tableData: [],
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      }
    }
  },
  created() {
    this.getFranchiseeList()
  },
  methods: {
    searchFranchiseeNameOptions(params) {
      return searchFranchisees(params)
    },
    getFranchiseeSearchParams(keyword) {
      return { keyword, size: 20 }
    },
    formatFranchisee(franchisee) {
      return [franchisee.franchisee_no, franchisee.franchisee_name].filter(Boolean).join('/')
    },
    getFranchiseeList() {
      this.listLoading = true
      const { page, limit, ...filters } = { ...this.search, ...this.listQuery }
      const params = filterEmptyAttr({ ...filters, page, size: limit })
      fetchFranchiseeList(params).then(response => {
        const pageData = response.data || {}
        this.tableData = pageData.list || []
        this.listQuery.total = pageData.total || 0
      }).finally(() => {
        this.listLoading = false
      })
    },
    searchFranchisees() {
      this.listQuery.page = 1
      this.getFranchiseeList()
    },
    resetSearch() {
      this.search = { franchisee_name: '' }
      this.searchFranchisees()
    },
    onPageChange() {
      this.getFranchiseeList()
    },
    openCreatePage() {
      this.$router.push({ name: 'Franchisee_Create' })
    },
    openDetailPage(franchisee) {
      this.$router.push({ name: 'Franchisee_Detail', query: { franchisee_no: franchisee.franchisee_no }})
    },
    openEditPage(franchisee) {
      this.$router.push({ name: 'Franchisee_Edit', query: { franchisee_no: franchisee.franchisee_no }})
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  margin: 40px 57px 50px 32px;
}
.page-title {
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.filter-content .filter-item {
  width: 30%;
}
</style>
